import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeGoogleSession } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      setError("Aucun jeton de session reçu.");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        await exchangeGoogleSession(sessionId);
        // clean hash from URL
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (e) {
        const msg = e?.response?.data?.detail || e.message || "Erreur d'authentification";
        setError(msg);
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="auth-callback-screen">
      <div className="surface surface-shadow p-10 max-w-md w-full reveal">
        <div className="label mb-3">Authentification</div>
        <div className="font-display text-3xl mb-4">Connexion en cours…</div>
        {!error ? (
          <div className="flex items-center gap-3 text-[var(--muted)]">
            <span className="spinner" /> Vérification Google et envoi du SMS.
          </div>
        ) : (
          <div className="space-y-4">
            <div className="border-2 border-[var(--ink)] bg-[var(--accent)] text-white p-3 font-mono text-xs">
              {error}
            </div>
            <button
              type="button"
              className="btn btn-secondary"
              data-testid="callback-back-to-login"
              onClick={() => navigate("/", { replace: true })}
            >
              Retour à la connexion
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
